import * as React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { loadingStates } from 'bundles/discussions/constants';
import CenteredLoadingSpinner from 'bundles/ui/components/CenteredLoadingSpinner';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/ListBody';

class ListBody extends React.LegacyComponentWithChildren {
  static propTypes = {
    loadingState: PropTypes.string.isRequired,
    children: PropTypes.array,
    fossilized: PropTypes.bool,
    emptyStatePlaceholderText: PropTypes.string,
  };

  static defaultProps = {
    children: [],
    fossilized: false,
    get emptyStatePlaceholderText() {
      return _t('No Results');
    },
  };

  state = {
    transitionEnded: false,
  };

  componentDidMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'body' does not exist on type 'ListBody'.
    this.body.addEventListener(
      'transitionend',
      function (e: $TSFixMe) {
        // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
        this.setState({ transitionEnded: true });
      }.bind(this)
    );
  }

  componentWillReceiveProps() {
    this.setState({ transitionEnded: false });
  }

  render() {
    let body;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'loadingState' does not exist on type 'Re... Remove this comment to see the full error message
    const { loadingState, emptyStatePlaceholderText, children, fossilized } = this.props;
    const { transitionEnded } = this.state;
    // @ts-expect-error ts-migrate(2533) FIXME: Object is possibly 'null' or 'undefined'.
    if (loadingState === loadingStates.DONE && children.length > 0) {
      body = <ol className="nostyle">{children}</ol>;
      // @ts-expect-error ts-migrate(2533) FIXME: Object is possibly 'null' or 'undefined'.
    } else if (loadingState === loadingStates.DONE && children.length === 0) {
      body = (
        <div className="message" role="status" aria-live="polite">
          {emptyStatePlaceholderText}
        </div>
      );
    } else if (loadingState === loadingStates.ERROR) {
      body = (
        <div className="message" role="alert" aria-live="assertive">
          {_t('There was a problem, please reload the page and try again.')}
        </div>
      );
    } else if (loadingState === loadingStates.LOADING) {
      body = (
        <div className="message" role="alert" aria-live="polite">
          <CenteredLoadingSpinner />
        </div>
      );
    } else {
      body = <div />;
    }

    const bodyClasses = classNames('rc-ListBody', {
      // @ts-expect-error ts-migrate(2533) FIXME: Object is possibly 'null' or 'undefined'.
      'c-list-expanded': loadingState === loadingStates.DONE && children.length > 0,
      'c-post-transition': transitionEnded,
    });

    const fossilClasses = classNames('c-pre-fossil', {
      'c-fossilized': fossilized,
    });
    return (
      <div
        className={bodyClasses}
        ref={(listBody) => {
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'body' does not exist on type 'ListBody'.
          this.body = listBody;
        }}
      >
        <div className={fossilClasses} />
        {body}
      </div>
    );
  }
}

export default ListBody;
